import {Component, OnInit} from '@angular/core';
import {ExcRestService} from 'exc-rest';
import {ExcTranslation} from 'exc-core';
import {ExcTab, IExcTab} from 'exc-tab';
import {ExcListConfig} from 'exc-controls';
import {ExcProgbarData} from '../app-exc-progbar/app-exc-progbar.component';
import {ExcIndicatorData} from '../app-exc-indicator/app-exc-indicator.component';
import {DatePipe, CurrencyPipe} from '@angular/common';
import {DefaultSettingsService} from '../default-settings-service.service';
import {ExcSigninService} from 'exc-signin';
import {AuditDetailsComponent} from "../audit-details/audit-details.component";

@Component({
  selector: 'app-inventory-details',
  templateUrl: './inventory-details.component.html',
  providers: [CurrencyPipe, DatePipe]
})
export class InventoryDetailsComponent extends ExcTranslation implements OnInit, IExcTab {

  Data: any;
  inventory = {Header: {}, Inventory: [], Charts: [], Attachments: [], History: []};
  tabinstance: any;
  historylistconfig: ExcListConfig = new ExcListConfig();
  attachmentlistconfig: ExcListConfig = new ExcListConfig();
  progbarBalanceParts: ExcProgbarData[] = [];
  progbarCurrentBalance: ExcProgbarData[] = [];
  indicatorData: ExcIndicatorData[] = [];
  totalClaims = 0;
  searchValueInventory: string = null;
  searchValueAttachments: string = null;
  constructor(private excRest: ExcRestService, private datePipe: DatePipe, private currencyPipe: CurrencyPipe, private excDss: DefaultSettingsService, private excSec: ExcSigninService) {
    super();
    const _self = this;
    _self.historylistconfig.selectionMode = 'none';
    _self.historylistconfig.paging = {pagingTotalRows: 1, pagingTotalPages: 1, pagingPage: 1, pagingPageSize: 10};
    _self.historylistconfig.OnSearch = function (searchValue, event?) {
      _self.searchValueInventory = searchValue || '';
      _self.reloadHistory();
    };
    _self.historylistconfig.OnPageChanged = (pageNo, event1) => {
      _self.historylistconfig.paging.pagingPage = pageNo;
      _self.reloadHistory();
    };
    _self.historylistconfig.OnRefresh = () => {
      _self.reloadHistory();
    };
    _self.historylistconfig.OnDetailLink = (item) => {
      const newItem = {...item,  AuditID: item.HistoryAuditID};
      new ExcTab(newItem.HistoryAuditID, AuditDetailsComponent, newItem, newItem.HistoryAuditID, {
        Unique: true, ReloadParent: function () {}
      }, true).Open();
    };

    _self.attachmentlistconfig.selectionMode = 'none';
    _self.attachmentlistconfig.paging = {pagingTotalRows: 1, pagingTotalPages: 1, pagingPage: 1, pagingPageSize: 10};
    _self.attachmentlistconfig.OnSearch = function (searchValue, event?) {
      _self.searchValueAttachments = searchValue || '';
      _self.reloadAttachments();
    };
    _self.attachmentlistconfig.OnPageChanged = (pageNo, event1) => {
      _self.attachmentlistconfig.paging.pagingPage = pageNo;
      _self.reloadAttachments();
    };
    _self.attachmentlistconfig.OnRefresh = () => {
      _self.reloadAttachments();
    };
    _self.attachmentlistconfig.OnDetailLink = (item, event?) => {};
  }

  ngOnInit() {
    this.initialLoad();
  }

  reloadHistory() {
    const _self = this;
    const url = _self.excRest.computeUrl('InventoryHistoryR_List', {auditId: this.Data.AuditID, InventoryID: this.Data.InventoryID});
    const mi = this.historylistconfig.GetMetaInfo();
    _self.historylistconfig.isLoading = true;
    _self.excRest.get(url, {MetaInfo: mi}).subscribe(ret => {
      if (ret) {
        _self.inventory.History = ret.data;
        _self.historylistconfig.paging = ret.paging;
      }
      _self.historylistconfig.isLoading = false;
    });
  }

  reloadAttachments() {
    const _self = this;
    const url = _self.excRest.computeUrl('InventoryAttachmentR_List', {auditId: this.Data.AuditID, InventoryID: this.Data.InventoryID});
    const mi = this.attachmentlistconfig.GetMetaInfo();
    _self.attachmentlistconfig.isLoading = true;
    _self.excRest.get(url, {MetaInfo: mi}).subscribe(ret => {
      if (ret) {
        _self.inventory.Attachments = ret.data;
        _self.attachmentlistconfig.paging = ret.paging;
      }
      _self.attachmentlistconfig.isLoading = false;
    });
  }
  initialLoad () {
    const _self = this;
    const inventoryUrl = _self.excRest.computeUrl('InventoryR_Summary', {auditId: this.Data.AuditID, InventoryID: this.Data.InventoryID});
    const mi = this.historylistconfig.GetMetaInfo();
    mi.dataSort = {AuditPlanMonth: 'desc'};
    _self.historylistconfig.isLoading = true;
    _self.attachmentlistconfig.isLoading = true;
    _self.excRest.get(inventoryUrl, {MetaInfo: mi}).subscribe(ret => {
      if (ret) {
        _self.inventory = ret.data;

        _self.historylistconfig.paging = ret.paging.Inventory;
        _self.attachmentlistconfig.paging = ret.paging.Attachments;
        _self.historylistconfig.isLoading = false;
        _self.attachmentlistconfig.isLoading = false;
      }
    });
  }

}
